import auth from '../../api/auth'
import axios from 'axios/index'

const AUTH_REQUEST = 'AUTH_REQUEST'
const AUTH_SUCCESS = 'AUTH_SUCCESS'
const AUTH_ERROR = 'AUTH_ERROR'
const AUTH_LOGOUT = 'AUTH_LOGOUT'

const state = {
  token: localStorage.getItem('user-token') || '',
  username: '',
  id: -1,
  status: ''
}

const getters = {
  isAuthenticated: state => !!state.token,
  authStatus: state => state.status,
  getName: state => state.username,
  getId: state => state.username
}

const actions = {
  async auth ({commit, dispatch}) {
    commit(AUTH_REQUEST)
    try {
      const res = await auth.checkAuth()
      commit(AUTH_SUCCESS, res.data.user)
      return res.status
    } catch (err) {
      commit(AUTH_ERROR, err)
      await dispatch('logout')
      return err.response.status
    }
  },
  async login ({commit, dispatch}, user) {
    commit(AUTH_REQUEST)
    try {
      const res = await auth.login(user)
      localStorage.setItem('user-token', res.data.user.token)
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + res.data.user.token
      commit(AUTH_SUCCESS, res.data.user)
      return res.status
    } catch (err) {
      commit(AUTH_ERROR, err)
      localStorage.removeItem('user-token')
      return err.response.status
    }
  },
  async logout ({commit, dispatch}) {
    commit(AUTH_LOGOUT)
    localStorage.removeItem('user-token')
  }
}

const mutations = {
  [AUTH_REQUEST]: (state) => {
    state.status = 'loading'
  },
  [AUTH_SUCCESS]: (state, user) => {
    state.status = 'success'
    state.username = user.username
    if (user.token) {
      state.token = user.token
    }
    state.id = user.id
  },
  [AUTH_ERROR]: (state) => {
    state.status = 'error'
  },
  [AUTH_LOGOUT]: (state) => {
    state.status = ''
    state.token = ''
    state.username = ''
    state.id = -1
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js